/*
 *   File : manage-questionnaire.js
 *   Author : https://evoqins.com
 *   Description : Manage questionnaire file.
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

// custom components
import { AmountInput, CustomTextInput } from '../../Components/FormElements';
import { CustomRadio } from '../../Components/Others';
import { PrimaryButton, SecondaryButton, TextButton } from '../../Components/Buttons';
import Icon from '../../Components/Icon/icon';
import { APIService } from '../../Service';


// custom styles
import color from '../../Style/color.scss';

const QUESTION_TYPES = [
    {
        id: 1,
        label: "Multiple choice"
    },
    {
        id: 2,
        label: "Range"
    },
    {
        id: 3,
        label: "Yes/No"
    },
];

const OPTION_TYPES = [
    {
        id: 1,
        label: "Amount"
    },
    {
        id: 2,
        label: "Years"
    },
    {
        id: 3,
        label: "Percentage"
    },
];

const OPTION = [
    {
        id: 1,
        label: "Yes"
    },
    {
        id: 2,
        label: "No"
    },

];


const ManageQuestionnaire = () => {

    const navigate = useNavigate();
    const { state } = useLocation();

    const [question, setQuestion] = useState("");
    const [questionError, setQuestionError] = useState("");

    const [starting, setStarting] = useState(null);
    const [startingError, setStartingError] = useState(null);

    const [ending, setEnding] = useState(null);
    const [endingError, setEndingError] = useState(null);

    const [defaultText, setDefault] = useState(null);

    const [defaultError, setDefaultError] = useState(null);

    const [step, setStep] = useState(null);
    const [stepError, setStepError] = useState(null);

    const [weight, setWeight] = useState(null);
    const [weightError, setWeightError] = useState(null);

    const [selectedQuestionType, setSelectedQuestionType] = useState(1);

    const [selectedOptionType, setSelectedOptionType] = useState(1);

    const [checked, setChecked] = useState([]);
    const [checkedBoolean, setCheckedBoolean] = useState([]);

    const [checkedError, setCheckedError] = useState(false);
    const [checkedBooleanError, setCheckedBooleanError] = useState(false);

    // const [selectedOption, setSelectedOption] = useState(1);

    const [isHovered, setIsHovered] = useState(null);

    const [addQuestion, setAddQuestion] = useState([
        {
            from: "",
            to: "",
            score: "",
        }
    ]);

    const [errors, setErrors] = useState([
        {
            from: "",
            to: "",
            score: "",
        }
    ]);

    const [option, setOption] = useState([
        {
            answer_id: null,
            answer: "",
            score: null,
            default: false
        }
    ]);

    const [errorsOption, setErrorsOption] = useState([
        {
            answer_id: null,
            answer: "",
            score: null,
            default: false
        }
    ]);

    const [optionBoolean, setOptionBoolean] = useState([
        {
            answer: "",
            score: "",
            default: false
        },
        {
            answer: "",
            score: "",
            default: false
        },
    ]);

    const [errorOptionBoolean, setErrorOptionBoolean] = useState([
        {
            answer: "",
            score: "",
            default: false
        },
        {
            answer: "",
            score: "",
            default: false
        },
    ]);


    useEffect(() => {
        if (state !== null) {
            setSelectedQuestionType(state.question_type);
            setQuestion(state.question);
            setWeight(state.weight);
        }

        if (state !== null && state.question_type === 1) {
            setOption(state.answers.map((item) => ({
                answer_id: item.id,
                answer: item.label,
                score: item.score,
                default: item.default,
            })));
            const error_options = state.answers.map((item) => ({
                answer_id: null,
                answer: "",
                score: null,
                default: false
            }))
            setErrorsOption(error_options);
            setChecked(state.answers.filter((item) => item.default).map((item) => state.answers.indexOf(item)));

        }

        if (state !== null && state.question_type === 2) {
            setSelectedOptionType(state.config.range_type);
            // if (selectedOptionType === state.config.range_type) {

            setStarting(state.config.start_range);
            setDefault(state.config.default_value);
            setStep(state.config.step_value);
            setEnding(state.config.end_range);

            setAddQuestion(state.config.slabs.map((item) => ({
                from: item.range_start,
                to: item.range_end,
                score: item.score
            })))
            // } else {
            // setStarting("");
            // setEnding("");
            // setDefault("");
            // setStep("");
            // setStartingError("");
            // setEndingError("");
            // setDefaultError("");
            // setStepError("");
            // }
        }


        if (state !== null && state.question_type === 3) {
            setOptionBoolean(state.answers.map((item) => ({
                answer: item.label,
                score: item.score,
                default: item.default,
            })));
            const error_options_boolean = state.answers.map((item) => ({
                answer: "",
                score: null,
                default: false
            }))
            setErrorOptionBoolean(error_options_boolean);
            setCheckedBoolean(state.answers.filter((item) => item.default).map((item) => state.answers.indexOf(item)));
        }

    }, [state]);

    useEffect(() => {
        setQuestionError("");
    }, [question]);

    useEffect(() => {
        setStartingError("");
    }, [starting]);

    useEffect(() => {
        setEndingError("");
    }, [ending]);

    useEffect(() => {
        setDefaultError("");
    }, [defaultText]);

    useEffect(() => {
        setStepError("");
    }, [step]);

    useEffect(() => {
        setWeightError("");
    }, [weight]);


    // handle select question type 
    const _handleSelectQuestionType = (id) => {
        setSelectedQuestionType(id);
        setChecked([]);
        setOption([
            {
                answer: "",
                score: "",
                default: false
            },
            {
                answer: "",
                score: "",
                default: false
            }
        ]);
        setErrorsOption([
            {
                answer: "",
                score: "",
                default: false
            },
            {
                answer: "",
                score: "",
                default: false
            }
        ]);
    };

    // handle select option type 
    const _handleSelectOptionType = (id) => {
        setSelectedOptionType(id);
        // if (state !== null && state.config.range_type === selectedOptionType) {
        //     setStarting(state.config.start_range)
        // } else {
        setStarting("");
        setEnding("");
        setDefault("");
        setStep("");
        setStartingError("");
        setEndingError("");
        setDefaultError("");
        setStepError("");

        setAddQuestion([
            {
                from: "",
                to: "",
                score: "",
            }
        ]);
        setErrors([
            {
                from: "",
                to: "",
                score: "",
            }
        ]);

        // }


    };

    // handle cancel 
    const _handleCancel = () => {
        navigate("/risk-assessment");
    };

    const _handleChangeAmount = (value, field, index) => {
        setAddQuestion(prev => {
            const updated_fund = [...prev];
            if (field === "score") {
                if (value === "" || /^[1-9]$|^10$/.test(value)) {
                    updated_fund[index][field] = value;
                }
            }
            else {
                updated_fund[index][field] = value;
            }
            return updated_fund;
        });

        const updated_error = [...errors];

        updated_error[index][field] = '';
        setErrors(updated_error);
    };

    const _handleChangeOption = (value, field, index) => {

        setOption(prev => {
            const updatedOption = [...prev];

            if (field === "score") {
                // Allow empty input for smooth typing, validate only when non-empty
                if (value === "" || /^[1-9]$|^10$/.test(value)) {
                    updatedOption[index][field] = value;
                }
            } else {
                updatedOption[index][field] = value; // No restriction for 'answer'
            }

            return updatedOption;
        });

        const updated_error = [...errorsOption];
        updated_error[index][field] = '';
        setErrorsOption(updated_error);
    };




    const _handleChangeOptionBoolean = (value, field, index) => {


        setOptionBoolean(prev => {
            const updatedOptionBoolean = [...prev];
            if (field === "score") {
                // Allow empty input for smooth typing, validate only when non-empty
                if (value === "" || /^[1-9]$|^10$/.test(value)) {
                    updatedOptionBoolean[index][field] = value;
                }
            }
            else {
                updatedOptionBoolean[index][field] = value; // No restriction for 'answer'
            }
            return updatedOptionBoolean;
        });

        const updated_error = [...errorOptionBoolean];
        updated_error[index][field] = '';
        setErrorOptionBoolean(updated_error);

    };

    const _handleAddNewOption = () => {

        setAddQuestion(prev => ([
            ...prev,
            {
                from: "",
                to: "",
                score: "",
            }
        ]));

        setErrors(prev => ([
            ...prev,
            {
                from: "",
                to: "",
                score: "",
            }
        ]));
    };


    const _handleAddOption = () => {

        setOption(prev => ([
            ...prev,
            {
                answer_id: null,
                answer: "",
                score: null,
                default: false
            }
        ]));

        setErrorsOption(prev => ([
            ...prev,
            {
                answer_id: null,
                answer: "",
                score: null,
                default: false
            }
        ]));
    };

    // handle delete fund
    const _handleDelete = (index) => {
        setAddQuestion(prev => {
            const updated_fund = [...prev];
            updated_fund.splice(index, 1);
            return updated_fund;
        });

        setErrors(prev => {
            const updated_error = [...prev];
            updated_error.splice(index, 1);
            return updated_error;
        });
    };

    // handle delete fund
    const _handleDeleteOption = (index, id) => {

        setOption(prev => {
            const updated_fund = [...prev];
            updated_fund.splice(index, 1);
            return updated_fund;
        });

        setErrorsOption(prev => {
            const updated_error = [...prev];
            updated_error.splice(index, 1);
            return updated_error;
        });
    };

    const _handleAddQuestion = () => {
        let is_valid = true;
        let updated_error;

        if (selectedQuestionType === 1) {
            updated_error = Array(option.length).fill(null).map(() => ({}));
        } else if (selectedQuestionType === 3) {
            updated_error = Array(optionBoolean.length).fill(null).map(() => ({}));
        } else {
            updated_error = [...errors];
        }

        if (question.trim().length === 0) {
            setQuestionError("Question is required");
            is_valid = false;
        };

        if (!weight && weight > 10) {
            setWeightError("Please provide weightage percentage");
            is_valid = false;
        }

        if (selectedQuestionType === 2) {
            if (!starting) {
                setStartingError("Please provide starting amount");
                is_valid = false;
            }

            if (!ending) {
                setEndingError("Please provide ending amount");
                is_valid = false;
            }

            if (!defaultText) {
                setDefaultError("Please provide default amount");
                is_valid = false;
            }

            if (!step) {
                setStepError("Please provide step amount");
                is_valid = false;
            }

            addQuestion?.forEach((question, index) => {
                if (!question.from) {
                    updated_error[index].from = 'Please provide from ';
                    is_valid = false;
                }

                if (!question.to) {
                    updated_error[index].to = 'Please provide to ';
                    is_valid = false;
                }

                if (!question.score) {
                    updated_error[index].score = 'Please provide  score';
                    is_valid = false;
                }
            });
        } else if (selectedQuestionType === 1) {
            if (!checked.length) {
                toast.error("At least one option must be selected as the default value");
                is_valid = false;
            }

            if (!weight) {
                setWeightError("Please provide weightage percentage");
                is_valid = false;
            }

            option.forEach((option, index) => {
                if (option.answer.trim().length === 0) {
                    updated_error[index].answer = 'Please provide option ';
                    is_valid = false;
                }

                if (!option.score) {
                    updated_error[index].score = 'Please provide score ';
                    is_valid = false;
                }

            });
        } else {
            if (!checkedBoolean.length) {
                toast.error("At least one option must be selected as the default value");
                is_valid = false;
            }

            if (!weight) {
                setWeightError("Please provide weightage percentage");
                is_valid = false;
            }

            optionBoolean.forEach((option, index) => {

                if (option.answer.trim().length === 0) {
                    updated_error[index].answer = 'Please provide option ';
                    is_valid = false;
                }

                if (option.score === "") {
                    updated_error[index].score = 'Please provide score ';
                    is_valid = false;
                }
            });
        }



        if (selectedQuestionType === 1) {
            setErrorsOption(updated_error)
        } else if (selectedQuestionType === 3) {
            setErrorOptionBoolean(updated_error)
        }
        else {
            setErrors(updated_error);
        }
        if (is_valid === true) {
            _createQuestion()
        }
    };


    const _createQuestion = () => {
        let is_post = true;
        let url = 'manage-risk/upsert';
        let request = {

            "question_id": state !== null ? state.question_id : null, // null- create , id- to 
            "question": question,
            "question_type": selectedQuestionType, // 1- Multiple choice , 2 - Range , 3- yes/no
            "weight": parseInt(weight),
            "order": state === null ? null : 83,
            "is_mandatory": true,
            "config": {
                "singular_postfix": "Percentage",
                "plural_postfix": "Percentages",
                "prefix_value": "",
                "range_type": selectedOptionType,
                "start_range": parseInt(starting),
                "default_value": parseInt(defaultText),
                "step_value": parseInt(step),
                "end_range": parseInt(ending),
                "slabs": selectedQuestionType === 2 ? addQuestion?.map((item) => ({ range_start: item.from, range_end: item.to, score: item.score })) : []
            },
            "answers": selectedQuestionType === 1 ? option : selectedQuestionType === 2 ? [] : selectedQuestionType === 3 ? optionBoolean : null

        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                navigate('/risk-assessment')
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
        })
    };

    const _handleChecked = (index) => {
        setChecked([index]); // Ensure only the latest checked index is stored

        setOption(prev => {
            const updated_option = prev.map((item, i) => ({
                ...item,
                default: i === index, // Set default to true for the checked one, false for others
            }));

            return updated_option;
        });

        setCheckedError(null); // Reset checked error
    };

    const _handleCheckedBoolean = (index) => {
        setCheckedBoolean([index]); // Ensure only the latest checked index is stored

        setOptionBoolean(prev => {
            const updated_option = prev.map((item, i) => ({
                ...item,
                default: i === index, // Set default to true for the checked one, false for others
            }));

            return updated_option;
        });

        setCheckedBooleanError(null); // Reset checked error
    };

    return (
        <section className='e-section-height pb-5' >
            <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                    <span className='text-decoration-hover-underline cursor-pointer'
                        onClick={() => navigate("/risk-assessment")}>Manage Risk Assessment</span> / <span className='e-font-weight-600'>{state ? 'Edit Question' : 'Create Question'} </span>
                </p>
            </div>

            {/* Manage question */}
            <div className='padding-52px-lr margin--80px-top'>
                <div className='e-bg-white border-radius-16 padding-32px-all min-vh-50'>
                    <h4 className='mb-4 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                        {state ? 'Edit question' : 'Create question'}
                    </h4>

                    <div className='row'>
                        <div className='col-9'>
                            <div className='d-flex flex-column gap-4'>
                                {/* Question */}
                                <CustomTextInput label="Question"
                                    placeholder="Enter question"
                                    type="text"
                                    autoFocus={true}
                                    required={true}
                                    value={question}
                                    error={questionError}
                                    className="w-100"
                                    inputType={2}
                                    handleChange={(e) => setQuestion(e)} />

                                {/* Weight age */}
                                <CustomTextInput label="Question weightage"
                                    placeholder="Weightage"
                                    type="number"
                                    autoFocus={false}
                                    showPercentage={true}
                                    required={true}
                                    value={weight}
                                    error={weightError}
                                    className="w-100"
                                    inputType={2}
                                    handleChange={(e) => setWeight(e)} />

                                {/* Question type radio button */}
                                <CustomRadio label="Question type"
                                    required={true}
                                    className="d-flex gap-3 align-items-center"
                                    data={QUESTION_TYPES}
                                    selected={selectedQuestionType}
                                    disabled={state !== null}
                                    // disabled={state !== null && (option) => option.value !== selectedQuestionType}
                                    handleSelect={(e) => _handleSelectQuestionType(e)} />

                                {/* Option type radio button */}
                                {selectedQuestionType === 1 ? null : selectedQuestionType === 3 ? null :
                                    <CustomRadio label="Option type"
                                        required={true}
                                        className="d-flex gap-3 align-items-center"
                                        data={OPTION_TYPES}
                                        selected={selectedOptionType}
                                        handleSelect={_handleSelectOptionType} />
                                }
                            </div>

                            {/* Add range values */}
                            {selectedQuestionType === 3 ?
                                <>

                                    <div className='pt-4 mt-2'>
                                        <h6 className='mb-3 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                            Add options and score value
                                        </h6>

                                        <div className='padding-18px-bottom'>
                                            {optionBoolean.map((data, key) => {

                                                return (
                                                    <div key={key} className='row pb-4 position-relative'>
                                                        {/*  Option */}
                                                        <div className='col-3'>

                                                            <CustomTextInput label="Option"
                                                                placeholder='Option'
                                                                type="text"
                                                                noIcon={true}
                                                                autoFocus={false}
                                                                required={true}
                                                                value={data.answer}
                                                                error={errorOptionBoolean[key].answer}
                                                                className="w-100"
                                                                inputType={2}
                                                                handleChange={(data) => _handleChangeOptionBoolean(data, 'answer', key)} />
                                                        </div>

                                                        {/* Score */}
                                                        <div className='col-3'>
                                                            <AmountInput label="Score"
                                                                type="text"
                                                                required={true}
                                                                noIcon={true}
                                                                value={data.score}
                                                                placeholder='Score'
                                                                error={errorOptionBoolean[key].score}
                                                                className="w-100"
                                                                inputType={2}
                                                                handleChange={(e) => _handleChangeOptionBoolean(e, 'score', key)} />
                                                        </div>


                                                        <div className='col-3 d-flex align-items-center justify-content-center'>
                                                            <div className='d-flex justify-content-center align-items-end pt-3'>
                                                                <Icon
                                                                    icon={checkedBoolean.includes(key) ? 'checkbox-active' : 'checkbox-inactive'}
                                                                    size={16}
                                                                    onClick={() => _handleCheckedBoolean(key)}  // Pass the index of the row
                                                                />
                                                                <p className='ps-1 mb-0 e-text-dark-gray e-font-14 e-primary-font e-font-weight-400 line-height-18px'>
                                                                    Default value
                                                                </p>
                                                                {checkedBooleanError && (
                                                                    <p className='text-danger'>{checkedBooleanError}</p>
                                                                )}
                                                            </div>
                                                        </div>


                                                        {/* <Icon icon="delete"
                                                            size="1rem"
                                                            color={isHovered === key ? color.fire_red : null}
                                                            onMouseEnter={() => setIsHovered(key)}
                                                            onMouseLeave={() => setIsHovered(null)}
                                                            className={`${option.length <= 1 ? 'e-disable d-none' : ''}  cursor-pointer position-absolute start-100 top-44px`}
                                                            onClick={() => _handleDeleteOption(key, data.answer_id)} /> */}
                                                    </div>


                                                )

                                            })}

                                        </div>



                                        <div className='d-flex align-items-center justify-content-end gap-16px'>
                                            <SecondaryButton name='Cancel'
                                                paddingBlock='padding-12px-tb padding-68px-lr'
                                                onClick={_handleCancel} />
                                            <PrimaryButton name={state ? 'Save' : 'Add Question'}
                                                paddingBlock={`padding-12px-tb  ${state ? 'padding-74px-lr' : 'padding-46px-lr'}`}
                                                onClick={(data) => _handleAddQuestion(data)} />
                                        </div>
                                    </div>
                                </>
                                :

                                selectedQuestionType === 1 ?
                                    <>

                                        {/* Add options and scores */}
                                        <div className='pt-4 mt-2'>
                                            <h6 className='mb-3 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                                Add options and score value
                                            </h6>

                                            <div className='padding-18px-bottom'>
                                                {option.map((data, key) => {

                                                    return (
                                                        <div key={key} className='row pb-4 position-relative'>
                                                            {/*  Option */}
                                                            <div className='col-3'>

                                                                <CustomTextInput label="Option"
                                                                    placeholder='Option'
                                                                    type="text"
                                                                    noIcon={true}
                                                                    autoFocus={false}
                                                                    required={true}
                                                                    value={data.answer}
                                                                    error={errorsOption[key]?.answer}
                                                                    className="w-100"
                                                                    inputType={2}
                                                                    handleChange={(data) => _handleChangeOption(data, 'answer', key)} />
                                                            </div>

                                                            {/* Score */}
                                                            <div className='col-3'>
                                                                <AmountInput label="Score"
                                                                    type="text"
                                                                    required={true}
                                                                    noIcon={true}
                                                                    value={data.score}
                                                                    placeholder='Score'
                                                                    error={errorsOption[key]?.score}
                                                                    className="w-100"
                                                                    inputType={2}
                                                                    handleChange={(e) => _handleChangeOption(e, 'score', key)} />
                                                            </div>


                                                            <div className='col-3 d-flex align-items-center justify-content-center'>
                                                                <div className='d-flex justify-content-center align-items-end pt-3'>
                                                                    <Icon
                                                                        icon={checked.includes(key) ? 'checkbox-active' : 'checkbox-inactive'}
                                                                        size={16}
                                                                        onClick={() => _handleChecked(key)}  // Pass the index of the row
                                                                    />
                                                                    <p className='ps-1 mb-0 e-text-dark-gray e-font-14 e-primary-font e-font-weight-400 line-height-18px'>
                                                                        Default value
                                                                    </p>
                                                                    {checkedError && (
                                                                        <p className='text-danger'>{checkedError}</p>
                                                                    )}
                                                                </div>
                                                            </div>


                                                            <Icon icon="delete"
                                                                size="1rem"
                                                                color={isHovered === key ? color.fire_red : null}
                                                                onMouseEnter={() => setIsHovered(key)}
                                                                onMouseLeave={() => setIsHovered(null)}
                                                                className={`${option.length <= 1 ? 'e-disable d-none' : ''}  cursor-pointer position-absolute start-100 top-44px`}
                                                                onClick={() => _handleDeleteOption(key, data.answer_id)} />
                                                        </div>


                                                    )

                                                })}

                                            </div>

                                            <div className=' padding-38px-bottom w-max'>
                                                <TextButton name='Add New Option'
                                                    add={true}
                                                    onClick={_handleAddOption} />
                                            </div>

                                            <div className='d-flex align-items-center justify-content-end gap-16px'>
                                                <SecondaryButton name='Cancel'
                                                    paddingBlock='padding-12px-tb padding-68px-lr'
                                                    onClick={_handleCancel} />
                                                <PrimaryButton name={state ? 'Save' : 'Add Question'}
                                                    paddingBlock={`padding-12px-tb  ${state ? 'padding-74px-lr' : 'padding-46px-lr'}`}
                                                    onClick={(data) => _handleAddQuestion(data)} />
                                            </div>
                                        </div>
                                    </>
                                    // null
                                    :
                                    <>
                                        <div className='pt-4 mt-2'>
                                            <h6 className='mb-3 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                                Add range values
                                            </h6>

                                            <div className='row'>
                                                {/* Starting value */}
                                                <div className='col-3'>
                                                    <AmountInput label="Starting value"
                                                        type="text"
                                                        required={true}
                                                        value={starting}
                                                        noIcon={selectedOptionType === 2 ? true : selectedOptionType === 3 ? true : false}
                                                        year={selectedOptionType === 2 && true}
                                                        percentage={selectedOptionType === 3 && true}
                                                        error={startingError}
                                                        className="w-100"
                                                        inputType={2}
                                                        handleChange={(e) => setStarting(e)} />
                                                </div>

                                                {/* Ending value */}
                                                <div className='col-3'>
                                                    <AmountInput label="Ending value"
                                                        type="text"
                                                        required={true}
                                                        noIcon={selectedOptionType === 2 ? true : selectedOptionType === 3 ? true : false}
                                                        year={selectedOptionType === 2 && true}
                                                        percentage={selectedOptionType === 3 && true}
                                                        value={ending}
                                                        error={endingError}
                                                        className="w-100"
                                                        inputType={2}
                                                        handleChange={(e) => setEnding(e)} />
                                                </div>
                                                {/* default value */}
                                                <div className='col-3'>
                                                    <AmountInput label="Default value"
                                                        type="text"
                                                        required={true}
                                                        noIcon={selectedOptionType === 2 ? true : selectedOptionType === 3 ? true : false}
                                                        year={selectedOptionType === 2 && true}
                                                        percentage={selectedOptionType === 3 && true}
                                                        value={defaultText}
                                                        error={defaultError}
                                                        className="w-100"
                                                        inputType={2}
                                                        handleChange={(e) => setDefault(e)} />
                                                </div>

                                                {/* step value */}
                                                <div className='col-3'>
                                                    <AmountInput label="Step value"
                                                        type="text"
                                                        required={true}
                                                        noIcon={selectedOptionType === 2 ? true : selectedOptionType === 3 ? true : false}
                                                        year={selectedOptionType === 2 && true}
                                                        percentage={selectedOptionType === 3 && true}
                                                        value={step}
                                                        error={stepError}
                                                        className="w-100"
                                                        inputType={2}
                                                        handleChange={(e) => setStep(e)} />
                                                </div>
                                            </div>
                                        </div>


                                        {/* Add options and scores */}
                                        <div className='pt-4 mt-2'>
                                            <h6 className='mb-3 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                                Add option and score
                                            </h6>

                                            <div className='padding-18px-bottom'>
                                                {addQuestion?.map((question, key) => {
                                                    return (
                                                        <div key={key} className='row pb-4 position-relative'>

                                                            {/*  From */}
                                                            <div className='col-3'>
                                                                <AmountInput label="From"
                                                                    type="text"
                                                                    required={true}
                                                                    value={question.from}
                                                                    error={errors[key]?.from}
                                                                    className="w-100"
                                                                    inputType={2}
                                                                    year={selectedOptionType === 2 ? true : false}
                                                                    percentage={selectedOptionType === 3 ? true : false}
                                                                    noIcon={selectedOptionType === 2 ? true : selectedOptionType === 3 ? true : false}
                                                                    handleChange={(data) => _handleChangeAmount(data, 'from', key)} />
                                                            </div>

                                                            {/* To */}
                                                            <div className='col-3'>
                                                                <AmountInput label="To"
                                                                    type="text"
                                                                    required={true}
                                                                    value={question.to}
                                                                    error={errors[key]?.to}
                                                                    className="w-100"
                                                                    inputType={2}
                                                                    noIcon={selectedOptionType === 2 ? true : selectedOptionType === 3 ? true : false}
                                                                    year={selectedOptionType === 2 ? true : false}
                                                                    percentage={selectedOptionType === 3 ? true : false}
                                                                    handleChange={(e) => _handleChangeAmount(e, 'to', key)} />
                                                            </div>

                                                            {/* Score */}
                                                            <div className='col-6'>
                                                                <AmountInput label="Score"
                                                                    type="text"
                                                                    required={true}
                                                                    value={question.score}
                                                                    error={errors[key]?.score}
                                                                    className="w-100"
                                                                    noIcon={true}
                                                                    inputType={2}
                                                                    handleChange={(e) => _handleChangeAmount(e, 'score', key)} />
                                                            </div>

                                                            <Icon icon="delete"
                                                                size="1rem"
                                                                color={isHovered === key ? color.fire_red : null}
                                                                onMouseEnter={() => setIsHovered(key)}
                                                                onMouseLeave={() => setIsHovered(null)}
                                                                className={`${addQuestion.length <= 1 ? 'e-disable d-none' : ''}  cursor-pointer position-absolute start-100 top-44px`}
                                                                onClick={() => _handleDelete(key)} />
                                                        </div>


                                                    )

                                                })}

                                            </div>

                                            <div className=' padding-38px-bottom w-max'>
                                                <TextButton name='Add New Option'
                                                    add={true}
                                                    onClick={_handleAddNewOption} />
                                            </div>

                                            <div className='d-flex align-items-center justify-content-end gap-16px'>
                                                <SecondaryButton name='Cancel'
                                                    paddingBlock='padding-12px-tb padding-68px-lr'
                                                    onClick={_handleCancel} />
                                                <PrimaryButton name={state ? 'Save' : 'Add Question'}
                                                    paddingBlock={`padding-12px-tb  ${state ? 'padding-74px-lr' : 'padding-46px-lr'}`}
                                                    onClick={state ? _handleAddQuestion : (data) => _handleAddQuestion(data)} />
                                            </div>
                                        </div>
                                    </>
                            }


                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default ManageQuestionnaire;
